import { InfoIcon } from '@capsicum/common-web/icons';
import { useTheme } from 'styled-components';

export const CustomInfoIcon = () => {
	const { colors } = useTheme();

	return <InfoIcon color={colors.icons.status.onInfo} height={32} width={32} />;
};
